const pageLevelTrustPilot = document.querySelector('.pageLevelTrustPilot');
const globalTrustPilot = document.getElementById('global-trustpilot-widget');

//this is used to hide global trust pilot widget if trustpilot exist in page level
if (pageLevelTrustPilot) {
	if (globalTrustPilot) {
		globalTrustPilot.style.display = 'none';
	}
}
